define("auth/utils/formatters/ig-post-from-basic-display", ["exports", "later/models/ig-post", "moment", "shared/utils/get-hashtags"], function (_exports, _igPost, _moment, _getHashtags) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  const createIgPostFromBasicDisplay = (_ref, socialProfile) => {
    let {
      caption,
      id,
      permalink,
      username,
      timestamp,
      media_type,
      media_url,
      thumbnail_url,
      is_deleted
    } = _ref;
    const post = {
      caption,
      id,
      permalink,
      username
    };
    post.timeCollected = Date.now();
    post.isDeleted = is_deleted || false;
    post.hasMedia = true;
    post.isSelected = false;
    post.createdTime = timestamp ? (0, _moment.default)(timestamp).unix() : null;
    post.type = media_type.toLowerCase();
    post.tags = (0, _getHashtags.default)(caption);
    const thumbnailUrl = post.type === 'video' ? thumbnail_url : media_url;
    post.thumbUrl = thumbnailUrl;
    post.lowResUrl = thumbnailUrl;
    post.highResUrl = media_url;
    post.standardResUrl = thumbnailUrl;

    if (media_type.toLowerCase() === 'video') {
      post.lowBandwidthVideoUrl = media_url;
      post.lowResVideoUrl = media_url;
      post.standardResVideoUrl = media_url;
    }

    if (socialProfile) {
      post.socialProfile = socialProfile;
      post.userId = socialProfile.get('basicDisplayId');
      post.username = socialProfile.get('nickname');
    }

    return _igPost.default.create(post);
  };

  var _default = createIgPostFromBasicDisplay;
  _exports.default = _default;
});